import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <IndexSection />
        <CardsSection />
        <FAQSection />
        <RankingSection />
        <CommentsSection />
        <TopicsSection />
        <ContactSection />
        <CarouselSection />
        <UpdatesSection />
        <AboutSection />
        <AppSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}